module.exports = __webpack_public_path__ + "img/unnamed.e16ccec.jpg";